/**
 * Per-competition rules registry — public entry point.
 *
 * Reads the activated rules from `./config` and exposes a single lookup
 * function `getCompetitionRule(leagueCode, season)`. Consumers should not
 * import individual rule files directly — they go through this lookup so
 * that adding / removing rules is a one-file edit in `./config.ts`.
 */

import { ENABLED_RULES } from './config';
import type { CompetitionRule } from './types';

export type { CompetitionRule } from './types';
export { ENABLED_RULES } from './config';

/**
 * Returns the `CompetitionRule` of the competition `leagueCode`, or `null` if
 * none is activated in `./config.ts` or the rule is tied to another season.
 * Consumers must treat `null` as "no per-competition override applies".
 */
export function getCompetitionRule(
  leagueCode: string | null | undefined,
  season: string | number | null | undefined,
): CompetitionRule | null {
  if (leagueCode == null || season == null) return null;
  const rule = ENABLED_RULES.find(r => r.leagueCode === String(leagueCode));
  if (!rule || (rule.season != null && rule.season !== String(season))) return null;
  return rule;
}
